import { designService, sealingService } from '@paragon/data-connections';
import { enqueueInfo } from '@paragon/notification-tools';

import { getActiveJobLayoutModel, isParagonJobOpen } from '../selectors/jobContextSelectors';
import { recordErrorDuringAnalysis } from './longRunningAnalysisActions';
import { AsyncThunkActionVoid } from './thunkActions';

const NON_PARAGON_JOB_MESSAGE = 'Cannot generate TDD for non-Paragon job.';
const ALREADY_SEALED_MESSAGE = 'Cannot generate TDD for job that is already sealed.';
const JOB_LOCKED_MESSAGE = 'Cannot generate TDD for job that is locked.';

export const generateTddInJob =
  (analysisReportGuid: string, componentDesignGuid: string): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();

    const { openContext } = state.application;
    const jobLayoutModel = getActiveJobLayoutModel(state);
    const isParagonJob = isParagonJobOpen(state);
    if (openContext?.type !== 'job' || !jobLayoutModel || !isParagonJob) {
      dispatch(recordErrorDuringAnalysis(componentDesignGuid, NON_PARAGON_JOB_MESSAGE, { fatal: false }));
      return;
    }

    if (jobLayoutModel.sealed) {
      dispatch(recordErrorDuringAnalysis(componentDesignGuid, ALREADY_SEALED_MESSAGE, { fatal: false }));
      return;
    }

    if (jobLayoutModel.locked) {
      dispatch(recordErrorDuringAnalysis(componentDesignGuid, JOB_LOCKED_MESSAGE, { fatal: false }));
      return;
    }

    try {
      const sealingServiceComponentDesign = await sealingService.componentDesigns.getByAnalysisRemoteKey(
        componentDesignGuid,
        openContext.jobId,
      );
      const sealingServiceComponentDesignExists = !!sealingServiceComponentDesign;
      await designService.componentDesigns.postCreateTddInJob(
        analysisReportGuid,
        openContext.jobId,
        sealingServiceComponentDesign?.id,
      );
      dispatch(enqueueInfo(`TDD ${sealingServiceComponentDesignExists ? 're' : ''}generated in job.`));
    } catch (exception) {
      console.error(exception);
      dispatch(recordErrorDuringAnalysis(componentDesignGuid, 'Error generating TDD.', { fatal: false }));
    }
  };
